import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

const useToastDismiss = (deps = []) => {
  const location = useLocation();

  useEffect(() => {
    toast.dismiss();
  }, [location.pathname, location.search, location.state, ...deps]);
};

export default useToastDismiss;
